import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import loginimg from "../Assets/Img/loginsideimg.png";
import axiosMain from "./../http/axiosMain";

function LoginWithEmail({ onClick }) {
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const navigate = useNavigate();

  const [rememberMe, setRememberMe] = useState(false);

  // Populate email field from localStorage on component mount
  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    if (savedEmail) {
      formik.setFieldValue("email", savedEmail);
      setRememberMe(true);
    }
  }, []);

  // Remember Me toggle function
  const handleRememberMeChange = (e) => {
    const isChecked = e.target.checked;
    setRememberMe(isChecked);

    if (isChecked && formik.values.email) {
      localStorage.setItem("rememberedEmail", formik.values.email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }
  };

  // Form validation schema using Yup
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
  });

  // Formik setup
  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      setServerError(""); // Clear any previous server error

      try {
        const response = await axiosMain.post("/api/auth/sendEmailOtp", {
          email: values.email,
        });

        if (response.status === 200) {
          if (rememberMe) {
            localStorage.setItem("rememberedEmail", values.email);
          } else {
            localStorage.removeItem("rememberedEmail");
          }

          localStorage.setItem("email", values.email);
          navigate("/otp", {
            state: { loginWithEmail: true, email: values.email },
          });
        } else {
          setServerError(
            response.data?.message || "Failed to send OTP. Try again."
          );
        }
      } catch (err) {
        setServerError(
          err.response?.data?.message || "Failed to send OTP. Try again."
        );
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="container-email p-0 mt-5 mb-5">
      <div className="card">
        <div className="row no-gutters">
          {/* Left Side (Image Section) */}
          <div className="col-xs-12 col-sm-12 col-md-6 left">
            <img src={loginimg} alt="sideimg" className="img" />
          </div>

          {/* Right Side (Login Section) */}
          <div className="col-xs-12 col-sm-12 col-md-6 right">
            <div className="row">
              <div className="col-12 text-center">
                <h2>
                  Collaborate.
                  <br /> Create. Connect.
                </h2>
                <form onSubmit={formik.handleSubmit}>
                  {/* Email Input Field */}
                  <div className="inputForm">
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your Email"
                      className={`input text-center ${
                        formik.errors.email && formik.touched.email
                          ? "is-invalid"
                          : ""
                      }`}
                      autoFocus
                      value={formik.values.email}
                      onChange={(e) => {
                        formik.handleChange(e);
                        if (rememberMe) {
                          localStorage.setItem(
                            "rememberedEmail",
                            e.target.value
                          );
                        }
                      }}
                      onBlur={formik.handleBlur}
                      style={{ color: "rgba(107, 142, 118, 1)" }}
                    />
                  </div>

                  {/* Email Error Message */}
                  {formik.errors.email && formik.touched.email && (
                    <p className="error-text">{formik.errors.email}</p>
                  )}

                  {/* Server Error Message */}
                  {serverError && <p className="error-text">{serverError}</p>}

                  {/* Remember Me Checkbox */}
                  <div className="flex-row d-flex justify-content-between align-items-center mt-3">
                    <div className="d-flex">
                      <input
                        type="checkbox"
                        checked={rememberMe}
                        onChange={handleRememberMeChange}
                        style={{ borderRadius: "0px" }}
                      />
                      <label className="ms-2">Remember me</label>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="button-submit btn-outline-success"
                    disabled={loading || !formik.isValid}
                  >
                    {loading ? "Sending OTP..." : "Login With Email"}
                  </button>
                </form>
              </div>
              {/* this changes do for navigate signup page */}
              {/* Footer Links */}
              <div className="col-12 footer">
                <div className="sign-link mt-auto mb-1">
                  Don't have an account? &nbsp;
                  {/* Add link to navigate back to the signup page */}
                  <Link to="/signup" className="btn-link">
                    Register &nbsp;
                  </Link>
                  here
                </div>
                <div className="sign-link mt-auto">
                  <Link to="/phone" className="btn-link btn-outline-success">
                    Login With Phone
                  </Link>
                </div>
                <div className="signup-instruction">
                  By continuing, you agree to our terms and conditions.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginWithEmail;
